module.exports = __webpack_public_path__ + "img/synchro_blocked.fb297df9.svg";